// extracted by mini-css-extract-plugin
export default {"search":"styles_search__4Gz3c","search__input":"styles_search__input__n8InP","search__icon":"styles_search__icon__5eUm-"};